export const toPlural = (word: string, condition: boolean, suffix = 's') =>
  `${word}${condition ? suffix : ''}`;
